import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberDetailsCommunicationHistoryActionLogWidget as MemberDetailsCommunicationHistoryActionLogWidgetView } from 'ui/views/widgets/memberDetailsCommunicationHistoryActionLogWidget';
import { MemberDetailsCommunicationHistoryActionLogWidgetService } from 'services/memberDetailsCommunicationHistoryActionLogWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import searchQuery from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsCommunicationHistoryActionLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryActionLogWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryActionLogWidget propName='propValue'/>
 */
class _MemberDetailsCommunicationHistoryActionLogWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.handleActionClick = this.handleActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined
        };

         // Member Detail instance
         this.memberDetailsCommunicationHistoryActionLogWidgetService = new MemberDetailsCommunicationHistoryActionLogWidgetService();

         // start member detail data fetch
         this.fetchComponentData();
    }

    async fetchComponentData() {
        log.debug( 'MemberDetailsCommunicationHistoryActionLogWidget.fetchComponentData()' );

        // cancel ongoing request
        this.memberDetailsCommunicationHistoryActionLogWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsCommunicationHistoryActionLogWidgetService.fetchComponentData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'MemberDetailsCommunicationHistoryActionLogWidget.handleActionClick()' );

        if( 'column' === type && 'actionId' === value.name  ) {

            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.ACTION_DETAIL,
                search: searchQuery.stringify( {
                    actionId: item.id,
                    origin: 'memberManagement'
                } )
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsCommunicationHistoryActionLogWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsCommunicationHistoryActionLogWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsCommunicationHistoryActionLogWidget.displayName = 'MemberDetailsCommunicationHistoryActionLogWidget';

// set default props
_MemberDetailsCommunicationHistoryActionLogWidget.defaultProps = {};

// prop types
_MemberDetailsCommunicationHistoryActionLogWidget.propTypes = {};

export const MemberDetailsCommunicationHistoryActionLogWidget = withRouter( _MemberDetailsCommunicationHistoryActionLogWidget );

